import { useNavItems } from "../hooks";
import { useAuthData } from "../contexts";
import { HStack } from "@chakra-ui/react";
import { AppUserNav } from "./AppUserNav";
import { AppSchoolCompanySelector } from "./AppSchoolCompanySelector";
import { UTIL } from "../config";
import { AppMessageProcess } from "./AppMessageProcess";

export const AppHeader = () => {
    const { user } = useAuthData();
    const userNavItems = useNavItems("user");

    return (
        <>
            <HStack
                minH={"4.5rem"}
                px={6}
                justifyContent={"space-between"}
                gap={6}
            >
                {user && UTIL.isSchoolCompanyMultiSelect(user?.userType) ? (
                    <AppSchoolCompanySelector />
                ) : (
                    <div></div>
                )}
                <HStack gap={6}>
                    <AppMessageProcess />
                    {user && <AppUserNav user={user} navItems={userNavItems} />}
                </HStack>
            </HStack>
        </>
    );
};
